import React from 'react';
import './index.scss';

export default ({ title, sub_title, description, id, callback }) => {
    return (
      <div className="search-item" onClick={() => callback(id)}>
        <div className="search-item-left">
          <div className="search-item-title">{title}</div>
          <div className="search-item-subtitle">{sub_title}</div>
          <div className="search-item-cont">{description}</div>
        </div>
        <div className="search-item-right">查看详情</div>
      </div>
    );
};
